const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change'
};

/* Alpha FriYAY freebie guard (Caplinger Creations): the Posh Pop bonus can only stay in the cart
   when all 3 FriYAY sets are in it, and only 1 copy. Otherwise it's taken out automatically. */
(function () {
  var FREE = 44346633453631;
  var NEED = [44346633191487, 44346633388095, 44346633420863];
  var busy = false;
  function check() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var free = null, have = {};
        (c.items || []).forEach(function (i) { have[i.variant_id] = true; if (i.variant_id === FREE) free = i; });
        if (!free) { busy = false; return; }
        var ok = NEED.every(function (v) { return have[v]; });
        var q = ok ? 1 : 0;
        if (free.quantity === q) { busy = false; return; }
        return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: free.key, quantity: q }) })
          .then(function () { busy = false; location.reload(); });
      })
      .catch(function () { busy = false; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check); else check();
  window.addEventListener('load', function () {
    if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(check, 400); });
  });
})();
